import React from "react";
import Instagram from "../assets/icons/Instagram";
import Linkedin from "../assets/icons/Linkedin";
import Twitter from "../assets/icons/Twitter";
import Youtube from "../assets/icons/Youtube";
import Me from "../assets/img/Me.jpg";

const Bio = () => (
  <div className="bio">
    <div className="bio-img">
      <img src={Me} />
    </div>
    <div className="bio-about">
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Excepturi est
      </p>
      <p>
        dolore ea, quam porro eos delectus accusantium officia quidem culpa.
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Vitae pariatur
      </p>
      <p>
        mollitia eveniet sint Ipsam doloribus iusto eum natus fugit dolore
        commodi ea tenetur exercitationem, voluptate deleniti architecto
        voluptas repellendus tempora? Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Perferendis, mollitia.
      </p>
      <div className="links">
        <a
          href="https://www.instagram.com/bihani.priya/"
          target="_blank"
          rel="noopener noreferrer"
          size="24"
        >
          <Instagram />
        </a>
        <a
          href="https://www.linkedin.com/in/kartik-gupta-3275651b8/"
          target="_blank"
          rel="noopener noreferrer"
          size="24"
        >
          <Linkedin />
        </a>
        <a
          href="https://twitter.com/Gkaartik"
          target="_blank"
          rel="noopener noreferrer"
          size="24"
        >
          <Twitter />
        </a>
        <a
          href="https://www.youtube.com/channel/UCAbp9YDBP6xEPjgeVxbJ1QQ"
          target="_blank"
          rel="noopener noreferrer"
          size="24"
        >
          <Youtube />
        </a>
      </div>
    </div>
  </div>
);

export default Bio;
